module.exports = __webpack_public_path__ + "img/google-play.bc420c49.svg";